import {RouterModule, Routes} from '@angular/router';
import {ThiemeCatalogGridComponent} from './components/catalog-grid/thieme-catalog-grid.component';

const APP_ROUTES: Routes = [
  {
    path: 'module/thieme-catalog/grid',
    component: ThiemeCatalogGridComponent,
    canActivate: ['CoreGuard'],
    data: {
      needsLogin: true,
      needsConfig: [
        'feature.thieme'
      ]
    }
  }
];

export const routing = RouterModule.forRoot(APP_ROUTES);
